import * as CONST from '../../constants';

const INITIAL_STATE = { loading: true, data: [], error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.MENU_LIST_REQUEST:
      return { ...INITIAL_STATE, loading: true };
    case CONST.MENU_LIST_SUCCESS:
      return { ...INITIAL_STATE, loading: false, data: action.data };
    case CONST.MENU_LIST_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error };
    default:
      return state;
  }
};
